<!-- 02_order_store_main_menu_info01.html -->
<template>
  <div>
    <div>
      <common-header title="설문조사" :showTitle="true" :showCart="false"  :showBack="true"/>
      <main>
        <div class="survey_q_bg container">
          <ul>
            <li class="mt40">
              <div>
                <span class="bold">1. 고객님의 성별은 어떻게 되시나요?</span>
              </div>
              <ul>
                <li class="pl30 mt20 normal_rdo" >
                  <label class="q_txt">
                    <input type="radio" name="radio_gender" value="M" v-model="gender"/> 남성</label>
                </li>
                <li class="pl30 mt20 normal_rdo" >
                  <label class="q_txt">
                    <input type="radio" name="radio_gender" value="F" v-model="gender"/> 여성</label>
                </li>
              </ul>
            </li>
            <li class="mt40">
              <div>
                <span class="bold">2. 고객님의 연령대는 어떻게 되시나요?</span>
              </div>
              <ul>
                <li class="pl30 mt20 normal_rdo" >
                  <label class="q_txt">
                    <input type="radio" name="radio_age" value="10" v-model="age"/> 10대</label>
                </li>
                <li class="pl30 mt20 normal_rdo" >
                  <label class="q_txt">
                    <input type="radio" name="radio_age" value="20" v-model="age"/> 20대</label>
                </li>
                <li class="pl30 mt20 normal_rdo" >
                  <label class="q_txt">
                    <input type="radio" name="radio_age" value="30" v-model="age"/> 30대</label>
                </li>
                <li class="pl30 mt20 normal_rdo" >
                  <label class="q_txt">
                    <input type="radio" name="radio_age" value="40" v-model="age"/> 40대</label>
                </li>
                <li class="pl30 mt20 normal_rdo" >
                  <label class="q_txt">
                    <input type="radio" name="radio_age" value="50" v-model="age"/> 50대 이상</label>
                </li>
              </ul>
            </li>
            <li class="mt40" v-for="(surveyQuestion,parentIndex) in fetchedSurveyQuestions">
              <div>
                <span class="bold">{{ (parentIndex + 3) + ' . ' + surveyQuestion.question }}</span>
                <div class="hint_txt" v-if="surveyQuestion.hintTxt"> {{surveyQuestion.hintTxt}} </div>
                <ul v-if="surveyQuestion.questionType === 'MULTI'">
                  <li class="pl30 mt20 normal_rdo" v-if="surveyQuestion.answerType === 'SINGLE'"
                      v-for="surveyQuestionAnswer in surveyQuestion.surveyQuestionAnswers">
                    <label class="q_txt"><input type="radio" :name="'radio' + (surveyQuestion.questionId)"
                           @click="setSurveyQuestionAnswer(surveyQuestion, surveyQuestionAnswer)"/>
                    {{ surveyQuestionAnswer.answerText }}</label>
                    <img v-if="surveyQuestionAnswer.answerImage" :src="surveyQuestionAnswer.answerImage">
                  </li>
                  <li class="pl30 mt20"  v-if="surveyQuestion.answerType === 'MULTI'"
                      v-for="surveyQuestionAnswer in surveyQuestion.surveyQuestionAnswers">
                    <label class="q_txt"><input type="checkbox" :name="'checkbox' + (surveyQuestion.questionId)"
                           @click="addSurveyQuestionAnswer(surveyQuestion, surveyQuestionAnswer)"/>
                    {{ surveyQuestionAnswer.answerText }}</label>
                    <img v-if="surveyQuestionAnswer.answerImage" :src="surveyQuestionAnswer.answerImage">
                  </li>
                  <div class="rdo-group01 mt20" v-if="surveyQuestion.answerType === 'NUMBER'">
                    <li v-for="surveyQuestionAnswer in surveyQuestion.surveyQuestionAnswers">
                        <input type="radio" :name="'radio' + (surveyQuestion.questionId)"
                            :id="'rdo01_0' + (surveyQuestionAnswer.answerId)"  @click="setSurveyQuestionAnswer(surveyQuestion, surveyQuestionAnswer)"/>
                        <label :for="'rdo01_0'+ (surveyQuestionAnswer.answerId)"> {{ surveyQuestionAnswer.answerText }}</label>
                        <img v-if="surveyQuestionAnswer.answerImage" :src="surveyQuestionAnswer.answerImage">
                    </li>
                  </div>
                </ul>
                <textarea class="mt20" v-if="surveyQuestion.questionType === 'ESSAY' && surveyQuestion.answerType === 'STRING'"
                          cols="30" rows="5"
                          @input="updateEssayAnswer(surveyQuestion, $event)"/>
                <input class="w90 mt20 pl30" v-if="surveyQuestion.questionType === 'ESSAY' && surveyQuestion.answerType === 'NUMBER'"
                       type="number" inputmode="numeric" pattern="[0-9]*" @input="updateEssayAnswer(surveyQuestion, $event)">
              </div>
              <div v-if="surveyQuestion.selectSurveyAnswers.length > 0">
                <ul>
                  <li v-for="(surveyQuestionAnswer, childIndex) in surveyQuestion.selectSurveyAnswers">
                    <ul v-if="surveyQuestionAnswer.addSurveyQuestions.length > 0">
                      <li v-for="(childSurveyQuestion, grandIndex) in surveyQuestionAnswer.addSurveyQuestions">
                        {{
                          (parentIndex + 1) + '-' + (surveyQuestion.selectSurveyAnswers.length > 1 ? (childIndex + 1) + '-' : '') + (grandIndex + 1) + ' . ' + childSurveyQuestion.question
                        }}
                        <ul v-if="childSurveyQuestion.questionType === 'MULTI'">
                          <li v-if="childSurveyQuestion.answerType === 'SINGLE'"
                              v-for="childSurveyQuestionAnswer in childSurveyQuestion.surveyQuestionAnswers">
                            <label> <input type="radio"
                                   :name="'radio' + (childSurveyQuestion.questionId)"
                                   @click="setSurveyQuestionAnswer(childSurveyQuestion, childSurveyQuestionAnswer)"/>
                                  {{ childSurveyQuestionAnswer.answerText }}</label>
                            <img v-if="childSurveyQuestionAnswer.answerImage"
                                 :src="childSurveyQuestionAnswer.answerImage">
                          </li>
                          <li v-if="childSurveyQuestion.answerType === 'MULTI'"
                              v-for="childSurveyQuestionAnswer in childSurveyQuestion.surveyQuestionAnswers">
                            <label> <input type="checkbox"
                                   :name="'checkbox' + (childSurveyQuestion.questionId)"
                                   @click="addSurveyQuestionAnswer(childSurveyQuestion, childSurveyQuestionAnswer)"/>
                            {{ childSurveyQuestionAnswer.answerText }}</label>
                            <img v-if="childSurveyQuestionAnswer.answerImage"
                                 :src="childSurveyQuestionAnswer.answerImage">
                          </li>
                        </ul>
                        <textarea
                          v-if="surveyQuestion.questionType === 'ESSAY' && surveyQuestion.answerType === 'STRING'"
                          cols="30" rows="5"
                          @input="updateEssayAnswer(surveyQuestion, $event)"/>
                        <input v-if="surveyQuestion.questionType === 'ESSAY' && surveyQuestion.answerType === 'NUMBER'"
                               type="number" inputmode="numeric" pattern="[0-9]*" @input="updateEssayAnswer(surveyQuestion, $event)">
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="footer-bottom">
          <button type="button" class="btn btn-full btn-primary" @click="completeSurvey">설문조사 제출</button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {YN} from "../AppConstants";
import {createSurveyAnswer} from "../../api";

export default {
  data() {
    return {
      surveyId: null,
      surveyMemberId : null,
      orderNo : null,
      gender : '',
      age : ''
    }
  },
  computed: {
    YN() {
      return YN
    },
    ...mapGetters(['fetchedSurveyQuestions']),
  },
  created() {
    // 설문조사 ID 파라미터
    const surveyId = this.$route.params.surveyId;
    const surveyMemberId = this.$route.params.surveyMemberId;
    const orderNo = this.$route.params.orderNo;
    this.surveyId = surveyId;
    this.surveyMemberId = surveyMemberId;
    this.orderNo = orderNo;

    // 설문조사 질문 리스트 조회
    this.showLoading(true);
    this.FETCH_SURVEY_QUESTIONS(surveyId)
      .then(response => {
        if (response.code !== '0000') {
          this.showAlert(response.message);
        }
      })
      .catch(error => this.showAlert("설문조사 질문 리스트 조회에 실패했습니다."))
      .finally(() => this.showLoading(false))
  },
  methods: {
    ...mapActions(['FETCH_SURVEY_QUESTIONS']),
    updateEssayAnswer(surveyQuestion, event) {
      // 주관식 답변 값 설정
      const essayAnswer = event.target.value;
      surveyQuestion.essayAnswer = essayAnswer;
    },
    extractSurveyMemberAnswers(surveyMemberAnswers, surveyQuestions) {
      // 설문조사 회원 응답 생성
      surveyQuestions.forEach(surveyQuestion => {
        const surveyMemberAnswer = {
          questionId: surveyQuestion.questionId,
          answerIds: [],
          essayAnswer: ''
        };

        if (surveyQuestion.questionType === 'MULTI') {
          // 객관식
          // 답변 존재 여부 검증
          if (surveyQuestion.selectSurveyAnswers.length == 0) {
            throw new Error(surveyQuestion.question + ' 를 답변 해주세요.');
          }

          if (surveyQuestion.answerType === 'SINGLE' || surveyQuestion.answerType === 'NUMBER') {
            // 단수 여부 검증
            if (surveyQuestion.selectSurveyAnswers.length > 1) {
              throw new Error(surveyQuestion.question + ' 의 답변은 1개만 가능합니다.');
            }
          }  else {
            // 복수 여부 검증
            if (surveyQuestion.selectSurveyAnswers.length > surveyQuestion.maxAnswerCount) {
              throw new Error(surveyQuestion.question + ' 의 답변은 ' + surveyQuestion.maxAnswerCount + '개 까지만 가능합니다.');
            }
          }

          surveyMemberAnswer.answerIds = surveyQuestion.selectSurveyAnswers.map(surveyQuestionAnswer => surveyQuestionAnswer.answerId);
        } else {
          // 주관식
          // 글자수 검증
          if (surveyQuestion.essayAnswer.trim().length < surveyQuestion.minAnswerLength) {
            throw new Error(surveyQuestion.question + '는 ' + surveyQuestion.minAnswerLength + '자리 이상이어야 합니다.');
          }
          if (surveyQuestion.essayAnswer.trim().length > surveyQuestion.maxAnswerLength && surveyQuestion.maxAnswerLength != 0) {
            throw new Error(surveyQuestion.question + '는 ' + surveyQuestion.maxAnswerLength + '자리 이하이어야 합니다.');
          }
          if(surveyQuestion.answerType === 'STRING') {

          } else {
            // 숫자 여부 검증
            if(isNaN(surveyQuestion.essayAnswer.trim())) {
              throw new Error(surveyQuestion.question + ' 는 ' + '숫자만 입력 해주세요.');
            }
          }

          surveyMemberAnswer.essayAnswer = surveyQuestion.essayAnswer.trim();
        }

        surveyMemberAnswers.push(surveyMemberAnswer);

        // 선택한 답변의 추가 질문 - 회원 응답 생성
        surveyQuestion.selectSurveyAnswers
          .forEach(surveyQuestionAnswer => this.extractSurveyMemberAnswers(surveyMemberAnswers, surveyQuestionAnswer.addSurveyQuestions));
      })
    },
    completeSurvey() {

      if(this.gender === ''){
        this.showAlert("성별을 선택해주세요.");
        return;
      }else if(this.age === ''){
        this.showAlert("연령대를 선택해주세요.");
        return;
      }

      const surveyMemberAnswers = [];

      // 답변 추출
      try {
        this.extractSurveyMemberAnswers(surveyMemberAnswers, this.fetchedSurveyQuestions);
      } catch (error) {
        this.showAlert(error.message);
        return;
      }

      // 파라미터
      const data = {
        ageRange : this.age,
        gender : this.gender,
        surveyMemberAnswers
      }

      // 설문조사 회원 답변 생성 API
      this.showLoading(true);
      createSurveyAnswer(this.surveyMemberId, data)
        .then(response => {
          if (response.code === '0000') {
            // 설문조사 답변 제출 완료 페이지로 이동
            this.$router.push(`/surveyGuest/complete/${this.orderNo}`);
          } else {
            this.showAlert(response.message);
          }
        })
        .catch(error => this.showAlert("설문조사 결과 제출에 실패했습니다."))
        .finally(() => this.showLoading(false))

    },
    setSurveyQuestionAnswer(surveyQuestion, surveyQuestionAnswer) {
      // 설문조사 질문의 선택 답변 초기화
      surveyQuestion.selectSurveyAnswers.forEach(selectSurveyQuestionAnswer => {
        selectSurveyQuestionAnswer.addSurveyQuestions.forEach(childSurveyQuestion => {
          $('input[name=radio' + childSurveyQuestion.questionId + ']').prop('checked', false);
          $('input[name=checkbox' + childSurveyQuestion.questionId + ']').prop('checked', false);
          childSurveyQuestion.selectSurveyAnswers = [];
        })
      })

      surveyQuestion.selectSurveyAnswers = [];
      // 설문조사 질문 선택 답변 추가
      surveyQuestion.selectSurveyAnswers.push(surveyQuestionAnswer);
    },
    addSurveyQuestionAnswer(surveyQuestion, surveyQuestionAnswer) {
      // 설문조사 질문의 선택 답변 존재 여부 확인
      const index = surveyQuestion.selectSurveyAnswers
        .findIndex(selectSurveyAnswer => selectSurveyAnswer.answerId == surveyQuestionAnswer.answerId);

      if (index !== -1) {
        // 존재하면 제거 및 초기화
        const removeAnswer = surveyQuestion.selectSurveyAnswers[index];

        removeAnswer.addSurveyQuestions.forEach(childSurveyQuestion => {
          $('input[name=radio' + childSurveyQuestion.questionId + ']').prop('checked', false);
          $('input[name=checkbox' + childSurveyQuestion.questionId + ']').prop('checked', false);
          childSurveyQuestion.selectSurveyAnswers = [];
        });

        surveyQuestion.selectSurveyAnswers.splice(index, 1);
      } else {
        // 존재하지 않으면 신규라서 추가
        surveyQuestion.selectSurveyAnswers.push(surveyQuestionAnswer);
      }
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/survey/SurveyGuestQuestionList.vue